module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "App"
  }, [(_vm.loaded) ? _c('router-view') : _c('BaseLoader'), _vm._v(" "), (_vm.dateTimePickerVisible) ? _c('DateTimePicker') : _vm._e(), _vm._v(" "), (_vm.confirmationVisible) ? _c('TheConfirmation') : _vm._e(), _vm._v(" "), _c('GlobalErrors'), _vm._v(" "), _c('GlobalMessages')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d43e784e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 661
// module chunks = 1